module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"parent_reviews":"前のレビュー","more_reviews":{"true":"{0} 件のレビューを表示","false":"{0} 件のレビューを非表示"}}}')
  delete Component.options._Ctor
}
